import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import SvgIcon from './base/SvgIcon.vue';
import ArrowStrokeLeftIcon from './icons/ArrowStrokeLeftIcon.vue';

interface Props {
  strokePosition: string;
  arrowDirection: string;
  hasStroke: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ArrowStroke',
  props: {
    strokePosition: null,
    arrowDirection: null,
    hasStroke: { type: Boolean }
  },
  emits: ['click-arrow'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  strokePosition: string;
  arrowDirection: string;
  hasStroke: boolean;
};





const arrowStrokeClass = computed(
  () => `arrow-stroke-container-${props.strokePosition}`
);

function handleClickArrow() {
  emits('click-arrow');
}

return { __sfc: true,props, emits, arrowStrokeClass, handleClickArrow, SvgIcon, ArrowStrokeLeftIcon }
}

})